import React from 'react';
import styled from 'styled-components';
import InputButton from '../components/Button';

const BgModal = styled.div`
     position: fixed;
     top: 0;
     left: 0;
     height: 100vh;
     width: 100vw;
     background-color: rgba(0,0,0,0.7);
     z-index:1040;

     display: flex;
     align-items: center;
     justify-content: center;
`;

const ContentModal = styled.div`
     background-color: #fff;
     width:88%;
     height: 88%;
     padding:1em;
     border-radius: 1em;
     position: relative;
    .btnClose{
        position: absolute;
        right: -15px;
        top: -15px;

        border-radius: 53px;
        height: 50px;
        font-size: 18px;
    }
    .scroll{
        width: 98%;
        height: 84vh;
        overflow: auto;
    }
`;

export default ({ children, onClickClose } :{
     children?:React.ReactNode,
     onClickClose:React.MouseEventHandler<HTMLButtonElement>
 }) => (
    <BgModal onClick={onClickClose}>
        <ContentModal onClick={(e) => e.stopPropagation()}>
            <InputButton onClick={onClickClose} className="important btnClose">
                <i className="fas fa-times-circle" />
            </InputButton>
            <div className="scroll">{children}</div>
        </ContentModal>
    </BgModal>
);
